module.exports = __webpack_public_path__ + "media/components/country-flag/static/cl-60a74ee1c70c3df75d13f2d2fb60f848.svg";